import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 12px 0 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`
